import { create } from "zustand";

interface ToggleState {
  isCerticationOpen: boolean;
  toggleCertification: () => void;
}

const useToogleCertification = create<ToggleState>((set) => ({
    isCerticationOpen: false,
    toggleCertification: () => set((state) => ({ isCerticationOpen: !state.isCerticationOpen })),
}));

export default useToogleCertification;